<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <div class="card card-auth with-shadow">
                <h2 class="auth-heading">
                    Check your Inbox
                    <span>
                        {{ $store.getters.data }}
                    </span>
                </h2>
                <span class="email-sent-icon">
                    <img src="@/assets/images/envelope-alt.png" /></span>

                <router-link to="/" class="
                        btn btn-primary
                        back-to-login-btn
                        text-decoration-none
                    ">
                    <span>BACK TO LOGIN</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() { }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        backToLogin() {
            this.$router.push({ name: 'login-page' })
        },
    }, // End of Component > mounted
} // End of export default
</script>
